import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export function IncludesSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-204">
          ¿QUÉ INCLUYE EFEMÉRIDES LISTAS SECUNDARIA?
        </h2>

        <div className="bg-blue-50 rounded-2xl p-5 border border-blue-100 mb-5" data-id="element-205">
          <h3 className="text-2xl font-bold mb-3 text-[#000000]" data-id="element-206">
            📚 Material organizado mes a mes
          </h3>

          <div className="flex justify-center mb-4" data-id="element-207">
            <img src="https://cdn.magicpatterns.com/uploads/xg5yLwdWuyaNe3aaeMankt/mockup_principal.png" alt="Efemérides Listas Secundaria" className="w-[280px] h-auto object-contain drop-shadow-lg rounded-lg" data-id="element-208" />
          </div>

          <p className="text-lg font-medium mb-2" data-id="element-209">Cada efeméride incluye:</p>

          <ul className="space-y-1.5 text-lg text-gray-800 mb-4 pl-4" data-id="element-210">
            <li className="flex items-start" data-id="element-211">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-212">•</span>
              <span data-id="element-213">texto de lectura</span>
            </li>
            <li className="flex items-start" data-id="element-214">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-215">•</span>
              <span data-id="element-216">comprensión lectora</span>
            </li>
            <li className="flex items-start" data-id="element-217">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-218">•</span>
              <span data-id="element-219">análisis de situaciones</span>
            </li>
            <li className="flex items-start" data-id="element-220">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-221">•</span>
              <span data-id="element-222">reflexión crítica</span>
            </li>
            <li className="flex items-start" data-id="element-223">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-224">•</span>
              <span data-id="element-225">ciudadanía</span>
            </li>
            <li className="flex items-start" data-id="element-226">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-227">•</span>
              <span data-id="element-228">producción escrita</span>
            </li>
            <li className="flex items-start" data-id="element-229">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-230">•</span>
              <span data-id="element-231">espacios para responder</span>
            </li>
          </ul>

          <p className="text-lg font-bold text-gray-900 inline-block px-2 mb-2 bg-[#EFF6FF]" data-id="element-232">
            Todo pensado especialmente para estudiantes de Secundaria.
          </p>

          <p className="text-lg text-gray-700" data-id="element-233">
            El contenido está organizado para que puedas encontrar rápidamente
            cada fecha y trabajarla en minutos.
          </p>
        </div>

        <div className="text-center mt-5" data-id="element-234">
          <CTAButton href="#compra" className="w-full md:w-auto" data-id="element-235">
            🔥 QUIERO RESOLVER MIS EFEMÉRIDES AHORA
          </CTAButton>
        </div>
      </div>
    </section>;
}